import { render } from "./Render.vue?vue&type=template&id=4c8ef198"
import script from "./Render.vue?vue&type=script&lang=js"
export * from "./Render.vue?vue&type=script&lang=js"
script.render = render

export default script